<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Configure Demo Event</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateDemoEvent" v-if="demoEvent">
                <div class="row justify-content-md-center">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-md-4">
                                <fg-input type="text"
                                          v-model="demoEvent.title"
                                          label="Event Title"
                                          placeholder="Enter Event Title"
                                          v-validate="rules.title"
                                          data-vv-name="title"
                                          cus-name="title"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-md-4" v-if="type.length">
                                <fg-select
                                        v-model="demoEvent.type"
                                        label="Type"
                                        v-validate="rules.type"
                                        data-vv-name="type"
                                        cus-name="type"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="type"
                                        selectedKey="id"
                                        >
                                </fg-select>
                            </div>
                          <div class="col-4">
                            <label>Start Date</label>
                            <datetime v-model="startDate" required
                                      input-class="form-control"
                                      placeholder="Choose a Date"
                                      type="datetime"
                                      :min-datetime="today"
                                      input-format="DD-MM-YYYY HH:mm"
                                      auto-continue>

                            </datetime>
                          </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="demoEvent.description"
                                        label="Event Description"
                                        placeholder="Enter Event Description"
                                        v-validate="rules.description"
                                        data-vv-name="description"
                                        cus-name="description"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                            <div class="col-md-12">
                                <fg-text-area
                                        rows="5"
                                        v-model="demoEvent.longDescription"
                                        label="Long Description"
                                        placeholder="Enter Event Long Description"
                                        v-validate="rules.longDescription"
                                        data-vv-name="Long Description"
                                        cus-name="Long Description"
                                        :has-errors="errors"
                                        :is-fields="fields">
                                </fg-text-area>
                            </div>
                        </div>
                        <div class="row">
                          <div class="col-4">
                                <fg-input type="text"
                                          v-model="demoEvent.jwStreamTitle"
                                          label="Event Description Message"
                                          placeholder="Enter Message"
                                      >
                                </fg-input>
                          </div>
                            <div  class="col-4">
                                <fg-input type="text"
                                          v-model="demoEvent.jwRtmpUrl"
                                          label="JW RTMP URL"
                                          placeholder="Enter JW RTMP URL">
                                </fg-input>
                            </div>
                          <div class="col-md-4">
                            <fg-input type="text"
                                      v-model="demoEvent.imgUrl"
                                      label="Event Image Url"
                                      placeholder="Enter Image Url"
                                     >
                            </fg-input>
                          </div>
                            <div class="col-4">
                                <fg-input type="text"
                                          v-model="demoEvent.chatrollEventUrl"
                                          label="Chat Roll Event Name"
                                          placeholder="Enter Chat Roll Event Name"
                                          v-validate="rules.chatrollEventUrl"
                                          data-vv-name="chatroll_event_name"
                                          cus-name="chatroll_event_name"
                                          :has-errors="errors"
                                          :is-fields="fields">
                                </fg-input>
                            </div>
                            <div class="col-4" v-if="experts.length">
                                <fg-select
                                        v-model="demoEvent.expertId"
                                        label="Expert ID"
                                        v-validate="rules.expertId"
                                        data-vv-name="expertId"
                                        cus-name="expertId"
                                        :has-errors="errors"
                                        :is-fields="fields"
                                        :list="experts"
                                        selectedKey="expertId"
                                        >
                                </fg-select>
                            </div>
                          <div class="col-md-4">
                            <fg-input type="text"
                                      v-model="demoEvent.videoCode"
                                      label="Promo Video Code"
                                      placeholder="Video Code"
                                      >
                            </fg-input>
                          </div>
                        </div>
                      <br/>
                      <legend>Corporate Community Demo Settings</legend><hr>
                      <br/>
                      <div class="col-12" v-if="corporations.length">
                        <fg-select
                          v-model="demoEvent.demoCorporationId"
                          label="Select Corporation for Corporate Community Page"
                          :list="corporations"
                          selectedKey="corporationId"
                        >
                        </fg-select>
                      </div>
                    </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Event
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import moment from 'moment'
    export default {
        name: 'EditDemoEvent',
        created (){
        this.$store.dispatch('GETDEMOEVENT').then(() =>{
            this.demoEvent = this.getDemoEvent;
            this.startDate = new Date(this.demoEvent.startDate).toISOString();
        })
        this.fetchExperts();
        this.fetchCorporations();
    },
    data () {
        let dateTime = new Date();
        return {
            newImage: [],
            today: dateTime.toISOString(),
            startDate: dateTime.toISOString(),
            demoEvent: this.getDemoEvent || {},
            rules: {
                title: {required : true, min: 5},
                description: {required : true, min : 15},
                longDescription: {required : true, min : 15},
                expertId: {required: true},
               chatrollEventUrl: {required: true},
                type: {required: true}
            },
            message: {
                error: false,
                text: ''
            },
            experts: [],
            corporations: [],
            corps: [],
            type: [{name:'Select Type'}, {id:1, name:'Live Event'}, {id:2, name:'Talk Event'}, {id:3, name:'Corporation Self-Hosted Event'}],
            status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
          eventType: [{name:'Select'}, {id:1, name:'Private'}, {id:0, name:'Public'}]
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            res.unshift({name: "Select an option"});
            this.corporations = res;
            console.log("this.corporations : ", this.corporations);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        updateDemoEvent () {
            let startDate = new Date(this.startDate).getTime();
                this.$validator.validateAll().then((result) => {
                  console.info(2)
                    if(result){
                      console.info(3)
                        this.demoEvent.startDate =  moment(startDate).format('MM/DD/YYYY H:mm:ss');
                        let updateEvent = () =>{
                            this.$store.dispatch('UPDATEDEMOEVENT', this.demoEvent)
                                    .then((res) => {
                                        console.log("UPDATE_DEMO_EVENT res : ", res);
                                        this.showPopup('Success!', 'DEMO Event is successfully updated', 'success', ()=>this.$router.push('/'))

                                    })
                                    .catch(err => {
                                        this.showPopup('Error!', 'some thing happen wrong', 'error')
                                        console.log("UPDATE_EVENT API error : ", err);
                                    })
                        }
                        updateEvent();
                    }
                })
        },
        fetchExperts () {
            this.$store.dispatch('FETCH_EXPERTS')
                    .then((res) => {
                        res.unshift({name: "Select an option"});
                        this.experts = res;
                        console.log("this.experts : ", this.experts);
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    }),
                    (err) => {
                        console.log("err : ", err);
                    }
        },
        updateValue(data){
//            this.event.img_url = data;
            this.event.img_url = data.path;
            this.newImage = data.value;
            console.log("updateValue data : ", data);
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'getDemoEvent']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/EditDemoEvent.vue